// TODO: We should updated this config

export default {
  hq: {
    clientId: '0oaei6duebeXaRX1n5d7',
    issuer: 'https://login.guesty.com/oauth2/ausei6sliu1aPxkL25d7',
    backofficeIssuer:
      'https://admin-login.guesty.com/oauth2/ausol0oegkyYMoyBk5d7',
  },
  'hq-trial': {
    clientId: '0oaei6duebeXaRX1n5d7',
    issuer: 'https://login.guesty.com/oauth2/ausei6sliu1aPxkL25d7',
  },
  'hq-staging0': {
    clientId: '0oa5uurgz2gTtijhN5d7',
    issuer: 'https://login-staging0.guesty.com/oauth2/aus5uux0nrEFk69cb5d7',
  },
  'hq-staging1': {
    clientId: '0oat6eljo6xs8mhCr697',
    issuer: 'https://login-staging1.guesty.com/oauth2/aust6evhgwKwf78Ou697',
  },
  'hq-staging2': {
    clientId: '0oat7m236teF03alr697',
    issuer: 'https://login-staging2.guesty.com/oauth2/aust7m1n7euCcNq2E697',
  },
  'hq-staging3': {
    clientId: '0oat8ucbboT0adJnI697',
    issuer: 'https://login-staging3.guesty.com/oauth2/aust8ucx8gmUr0NYl697',
  },
  'hq-staging4': {
    clientId: '0oat9vzewxX1iTVUn697',
    issuer: 'https://login-staging4.guesty.com/oauth2/aust9vxu28fx6AFPQ697',
  },
  'hq-staging5': {
    clientId: '0oatenxox1zJlgBG4697',
    issuer: 'https://login-staging5.guesty.com/oauth2/austenhy3oNLWu6P0697',
  },
  'hq-staging6': {
    clientId: '0oat9w28lskWJJwCc697',
    issuer: 'https://login-staging6.guesty.com/oauth2/aust9w3v53kw0ib3S697',
  },
  'hq-staging7': {
    clientId: '0oat9vz3fdJfwzfCs697',
    issuer: 'https://login-staging7.guesty.com/oauth2/aust9vz21xUV4hjob697',
  },
  'hq-staging8': {
    clientId: '0oatbulvsck8P0KMe697',
    issuer: 'https://login-staging8.guesty.com/oauth2/austbuju8qVRTrYUD697',
  },
  'hq-staging9': {
    clientId: '0oatbug10c9PND38H697',
    issuer: 'https://login-staging9.guesty.com/oauth2/austbukoz26Qbayb8697',
  },
  'hq-staging10': {
    clientId: '0oasox7b5fAxSfNnc697',
    issuer: 'https://login-staging10.guesty.com/oauth2/aussox9h2xVm8puFk697',
  },
  'hq-staging11': {
    clientId: '0oatbunv84yVvztPC697',
    issuer: 'https://login-staging11.guesty.com/oauth2/austbunzlwUZWmaWQ697',
  },
  'hq-staging12': {
    clientId: '0oatbuisjpFTFpIQA697',
    issuer: 'https://login-staging12.guesty.com/oauth2/austbukscsefTedQn697',
  },
  'hq-staging13': {
    clientId: '0oae1nh66f09x4mrO5d7',
    issuer: 'https://login-staging13.guesty.com/oauth2/ause1njnw4OeFB2qb5d7',
    backofficeIssuer:
      'https://admin-login-staging13.guesty.com/oauth2/ausq8h32jmQtUmOoy5d7',
  },
  'hq-staging14': {
    clientId: '0oatbuhbebbniVp5b697',
    issuer: 'https://login-staging14.guesty.com/oauth2/austbumnkiAw71y2E697',
  },
  'hq-staging15': {
    clientId: '0oatenwdtezzKDW7F697',
    issuer: 'https://login-staging15.guesty.com/oauth2/austenqbsr9uOewyM697',
  },
  'hq-staging16': {
    clientId: '0oatenxbviXFnS7IZ697',
    issuer: 'https://login-staging16.guesty.com/oauth2/austenk77aQ2Bk4VU697',
  },
  'hq-staging17': {
    clientId: '0oateny1d1SYW1b3W697',
    issuer: 'https://login-staging17.guesty.com/oauth2/austenhi3ljADMVKL697',
  },
  'hq-staging18': {
    clientId: '0oatenspd1BJYcLX9697',
    issuer: 'https://login-staging18.guesty.com/oauth2/austenrrz1meGCWvp697',
  },
  'hq-staging19': {
    clientId: '0oateo59ce872R2pg697',
    issuer: 'https://login-staging19.guesty.com/oauth2/austenwvpyjxGZLb9697',
  },
  'hq-staging20': {
    clientId: '0oatenic3huboHHcO697',
    issuer: 'https://login-staging20.guesty.com/oauth2/austeni86kFdzevPU697',
  },
  'hq-sandbox': {
    clientId: '0oaa46egp0ptn5Ad1697',
    issuer: 'https://login-sandbox.guesty.com/oauth2/ausa46kq3mcCDQGi8697',
  },
};
